import axios from 'axios';
import qs from 'qs';

axios.defaults.withCredentials = true;
const ax = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
});

export function setToken(token?: string) {
    if (!token) {
        window.localStorage.removeItem('token');
    } else {
        window.localStorage.token = token;
    }
}

export function getToken() {
    return window.localStorage.token;
}

ax.interceptors.request.use(async config => {
    const token = getToken();
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
});

export const getFetcher = ({ url, params }: { url: string; params: object }) =>
    ax
        .get(url, {
            params,
            paramsSerializer: {
                serialize: p => {
                    return qs.stringify(p, { arrayFormat: 'repeat' });
                },
            },
        })
        .then(res => res.data)
        .catch(err => {
            throw err.response;
        });

export default ax;
